import { PlaneUtils } from "./PlaneUtils";
import * as THREE from "three";
import { ASSET_TYPE, BearAsset } from "./AssetConst";
import { isIOS } from "@/utils";

interface VideoAsset {
    src: string;
    plane: THREE.Mesh;
    videoElement: HTMLVideoElement;
}
//Bind FS to an asset

export class VideoAssetManager {
    private planeUtils: PlaneUtils = new PlaneUtils();

    addAudioOnAsset(asset: BearAsset, src, pit: HTMLElement) {
        const domElement = document.createElement("audio");
        domElement.setAttribute("crossorigin", "anonymous");
        domElement.setAttribute("src", src);
        if (asset.is_play_in_loop) {
            domElement.setAttribute("loop", "");
        }
        if (asset.autoplay_on_texture) {
            domElement.setAttribute("autoplay", "");
            domElement.addEventListener(
                "loadeddata",
                () => {
                    domElement.play();
                },
                false
            );
        }
        pit.appendChild(domElement);
        (asset.domElement as any) = domElement;
    }

    addVideoPlane(
        asset: BearAsset,
        src,
        markerWith,
        markerHight,
        coords,
        pit: HTMLElement
    ): THREE.Mesh {
        const material = new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            depthWrite: true,
            depthTest: true,
            alphaTest: 0.5,
            transparent: true
        });
        const geometry = new THREE.PlaneGeometry(1, 1);

        const domElement = document.createElement("video");
        domElement.setAttribute("crossorigin", "anonymous");
        domElement.setAttribute("src", src);
        domElement.setAttribute("webkit-playsinline", "");
        domElement.setAttribute("playsinline", "");
        if (asset.is_play_in_loop) {
            domElement.setAttribute("loop", "");
        }

        if (asset.autoplay_on_texture) {
            domElement.setAttribute("autoplay", "");
            domElement.addEventListener(
                "loadeddata",
                () => {
                    // Video is loaded and can be played
                    domElement.play();
                },
                false
            );
        }

        //michael
        domElement.style.display = "none";

        asset.domElement = domElement;
        const id = "threevideo-" + asset.id;
        domElement.setAttribute("id", id);
        pit.appendChild(domElement);
        domElement.load();

        const texture = new THREE.VideoTexture(
            document.getElementById(id) as HTMLVideoElement
        );
        console.log("added in pit "+id)
        //TODO add max anisotropy
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.format = THREE.RGBFormat;
        material.map = texture;
        const plane = new THREE.Mesh(geometry, material);
        plane.scale.set(coords.width, coords.height, 1);
        (plane as any).video = domElement;
        (plane as any).needsUpdate = true;
        if (asset.is_alpha_channel_video) {
            this.planeUtils.fnCreateAlphaPlane(
                plane,
                asset,
                coords,
                texture,
                markerWith,
                markerHight
            );
        } else if (asset.key_color > 1) {
            this.planeUtils.fnCreateGreenPlane(
                plane,
                asset,
                coords,
                texture,
                asset.key_color,
                markerWith,
                markerHight
            );
        } else {
            this.planeUtils.fnCreatePlane(
                plane,
                asset,
                coords,
                markerWith,
                markerHight
            );
            material.map = texture;
            plane.material = material;
        }
        return plane;
    }
}
